module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Preface"
    }
  }, [_vm._v("Preface and Acknowledgments")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocf1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#id1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tocpada"
  }, [_vm._v("I.")]), _vm._v(" The Contents of the Dictionary")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#id2"
    }
  }, [_vm._v("Preliminary")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#id3"
    }
  }, [_vm._v("The Historical Background")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#id4"
    }
  }, [_vm._v("The Anglicization of Foreign Words")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#id5"
    }
  }, [_vm._v("The Meaning of ‘Foreign’")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#id6"
    }
  }, [_vm._v("Some Positive Criteria")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#id7"
    }
  }, [_vm._v("Some Negative Criteria")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#id8"
    }
  }, [_vm._v("Practical Conclusions")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#id9"
    }
  }, [_vm._v("‘Current’ Words")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#id10"
    }
  }, [_vm._v("‘Current’ Phrases")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#id11"
    }
  }, [_vm._v("The Classification of ‘Foreign’ Expressions")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#id12"
    }
  }, [_vm._v("Why Some Expressions Remain ‘Foreign’")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#id13"
    }
  }, [_vm._v("The Dating of ‘Foreign’ Expressions")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#id14"
    }
  }, [_vm._v("Some Tables of Statistics")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#id15"
    }
  }, [_vm._v("The Historical Significance of ‘Foreign’ Expressions")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#id16"
    }
  }, [_vm._v("The Origins of Quotations")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocf1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#id17"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tocpadb"
  }, [_vm._v("II.")]), _vm._v(" The Use and Abuse of ‘Foreign’ Words and Phrases")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#id18"
    }
  }, [_vm._v("‘Description’ and ‘prescription’")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#id19"
    }
  }, [_vm._v("The Use of ‘Foreign’ Expressions")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#id20"
    }
  }, [_vm._v("The Pronunciation and Spelling of ‘Foreign’ Expressions")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#id21"
    }
  }, [_vm._v("The Pronunciation and Spelling of Latin")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#id22"
    }
  }, [_vm._v("The Spelling of Greek")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#id23"
    }
  }, [_vm._v("The Pronunciation of Greek")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#id24"
    }
  }, [_vm._v("Languages Written in Non-Roman Scripts")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#id25"
    }
  }, [_vm._v("The Spelling of European Languages")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#id26"
    }
  }, [_vm._v("The Pronunciation of European Languages")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#id27"
    }
  }, [_vm._v("The Use of Foreign Feminine Forms in English")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#id28"
    }
  }, [_vm._v("The Use of Foreign Plurals in English")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocf1"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#id29"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tocpad"
  }, [_vm._v("III.")]), _vm._v(" The Arrangement of the Dictionary")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#id30"
    }
  }, [_vm._v("The Alphabetic Arrangement")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#id31"
    }
  }, [_vm._v("The Head-Word")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#id32"
    }
  }, [_vm._v("The Etymology")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#id33"
    }
  }, [_vm._v("Specialized and Technical Usage")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#id34"
    }
  }, [_vm._v("The Definition")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#id35"
    }
  }, [_vm._v("The Date of Introduction")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#id36"
    }
  }, [_vm._v("Notes on Points of Interest")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#id37"
    }
  }, [_vm._v("Cross-References")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#id38"
    }
  }, [_vm._v("Illustrative Quotations")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Abbreviations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A Dictionary of Foreign Words and Phrases")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_vm._v("Appendix: Language of Origin and Date of Introduction")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 75
// module chunks = 0